var map = {
	"./careers/hero-koza.png": "PL/G"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Y4jV";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\/hero\-koza\.png$
// module id = Y4jV
// module chunks = 0